export default "__VITE_ASSET__DG8o8Vig__"